const CombinationLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={233.955}
    height={61.668}
    data-name="Logo Montecon_RGB 2023_AZUL Y CELESTE 1"
  >
    <g data-name="Group 13339">
      <path
        d="M202.04 89.819V72.94h4.944l4.028 6.533 4.028-6.533h4.944v16.879h-4.654v-9.694l-4.318 6.608h-.1l-4.292-6.56v9.646z"
        data-name="Path 15710"
        style={{
          fill: '#0d206c',
        }}
        transform="translate(-136.586 -52.55)"
      />
      <path
        d="M281.345 87.039a9.541 9.541 0 0 1-12.974.026 8.328 8.328 0 0 1-2.591-6.2v-.048a8.366 8.366 0 0 1 2.62-6.217 9.541 9.541 0 0 1 12.974-.026 8.328 8.328 0 0 1 2.591 6.2v.048a8.366 8.366 0 0 1-2.62 6.217zm-9.549-3a4.269 4.269 0 0 0 6.184.022 4.549 4.549 0 0 0 1.206-3.194v-.048a4.6 4.6 0 0 0-1.229-3.22 4.037 4.037 0 0 0-3.112-1.336 3.97 3.97 0 0 0-3.075 1.314 4.573 4.573 0 0 0-1.2 3.194v.048a4.62 4.62 0 0 0 1.217 3.22z"
        data-name="Path 15711"
        style={{
          fill: '#0d206c',
        }}
        transform="translate(-176.597 -51.985)"
      />
      <path
        d="M330.214 89.819V72.94h4.363l6.943 8.924V72.94h4.631v16.879h-4.1l-7.211-9.259v9.259h-4.63z"
        data-name="Path 15712"
        style={{
          fill: '#0d206c',
        }}
        transform="translate(-217.041 -52.55)"
      />
      <path
        d="M392.673 89.819v-12.78h-5.063v-4.1h14.805v4.1h-5.063v12.78z"
        data-name="Path 15713"
        style={{
          fill: '#0d206c',
        }}
        transform="translate(-253.072 -52.55)"
      />
      <path
        d="M441.95 89.819V72.94h13.577v3.98h-8.946v2.558h8.1v3.689h-8.1v2.677h9.065v3.98h-13.7z"
        data-name="Path 15714"
        style={{
          fill: '#0d206c',
        }}
        transform="translate(-287.183 -52.55)"
      />
      <path
        d="M501.054 89.593a8.583 8.583 0 0 1-8.7-8.726v-.048a8.479 8.479 0 0 1 2.543-6.247 8.649 8.649 0 0 1 6.355-2.531 8.3 8.3 0 0 1 7.163 3.522l-3.522 2.725a4.653 4.653 0 0 0-3.693-1.978 3.69 3.69 0 0 0-2.881 1.292 4.608 4.608 0 0 0-1.147 3.172v.048a4.7 4.7 0 0 0 1.132 3.22 3.681 3.681 0 0 0 2.893 1.292 4.028 4.028 0 0 0 2.1-.517 6.931 6.931 0 0 0 1.712-1.53l3.522 2.509a9.918 9.918 0 0 1-3.086 2.811 8.74 8.74 0 0 1-4.389 1z"
        data-name="Path 15715"
        style={{
          fill: '#0d206c',
        }}
        transform="translate(-318.82 -51.985)"
      />
      <path
        d="M562.965 87.039a9.541 9.541 0 0 1-12.974.026 8.328 8.328 0 0 1-2.591-6.2v-.048a8.366 8.366 0 0 1 2.617-6.221 9.541 9.541 0 0 1 12.974-.026 8.328 8.328 0 0 1 2.591 6.2v.048a8.366 8.366 0 0 1-2.617 6.221zm-9.549-3a4.269 4.269 0 0 0 6.184.022 4.549 4.549 0 0 0 1.206-3.194v-.048a4.6 4.6 0 0 0-1.229-3.22 4.037 4.037 0 0 0-3.112-1.336 3.97 3.97 0 0 0-3.075 1.314 4.573 4.573 0 0 0-1.2 3.194v.048a4.62 4.62 0 0 0 1.217 3.22z"
        data-name="Path 15716"
        style={{
          fill: '#0d206c',
        }}
        transform="translate(-353.376 -51.985)"
      />
      <path
        d="M611.844 89.819V72.94h4.363l6.943 8.924V72.94h4.631v16.879h-4.1l-7.211-9.259v9.259h-4.63z"
        data-name="Path 15717"
        style={{
          fill: '#0d206c',
        }}
        transform="translate(-393.826 -52.55)"
      />
    </g>
    <g data-name="Group 13340">
      <path
        d="M206.706 140.477a1.965 1.965 0 0 1-.558.674 2.447 2.447 0 0 1-.819.406 3.6 3.6 0 0 1-.994.134h-1.593v2.316H202v-6.557h2.453a3.278 3.278 0 0 1 1.005.145 2.319 2.319 0 0 1 .778.413 1.789 1.789 0 0 1 .5.655 2.122 2.122 0 0 1 .175.875 2.025 2.025 0 0 1-.2.938zm-1.016-1.981a2.089 2.089 0 0 0-1.281-.361h-1.664v2.885h1.627a2.433 2.433 0 0 0 .737-.1 1.774 1.774 0 0 0 .573-.294 1.268 1.268 0 0 0 .365-.458 1.356 1.356 0 0 0 .127-.6 1.248 1.248 0 0 0-.484-1.072z"
        data-name="Path 15718"
        style={{
          fill: '#0d206c',
        }}
        transform="translate(-136.56 -93.045)"
      />
      <path
        d="M224 141.206a3.749 3.749 0 0 1-.2 1.266 2.433 2.433 0 0 1-.558.908 2.36 2.36 0 0 1-.86.547 3.231 3.231 0 0 1-1.121.182 3.167 3.167 0 0 1-1.109-.182 2.336 2.336 0 0 1-.864-.544 2.481 2.481 0 0 1-.558-.893 3.573 3.573 0 0 1-.2-1.229v-3.811h.741v3.764a2.318 2.318 0 0 0 .529 1.638 1.918 1.918 0 0 0 1.474.573 1.891 1.891 0 0 0 1.441-.544 2.212 2.212 0 0 0 .532-1.619v-3.812h.741v3.756z"
        data-name="Path 15719"
        style={{
          fill: '#0d206c',
        }}
        transform="translate(-146.936 -93.045)"
      />
      <path
        d="M242.659 138.118h-4v2.237h3.578v.674h-3.578v2.293h4.047V144h-4.786v-6.56h4.739v.674z"
        data-name="Path 15720"
        style={{
          fill: '#0d206c',
        }}
        transform="translate(-159.108 -93.039)"
      />
      <path
        d="m259.286 144.006-1.9-2.546h-1.873v2.546h-.741v-6.556h2.818a3.2 3.2 0 0 1 .979.141 2.192 2.192 0 0 1 .745.4 1.793 1.793 0 0 1 .477.618 1.879 1.879 0 0 1 .168.8 1.986 1.986 0 0 1-.13.737 1.7 1.7 0 0 1-.369.562 2.09 2.09 0 0 1-.566.4 2.48 2.48 0 0 1-.711.223l2.014 2.677zm-.506-5.528a1.988 1.988 0 0 0-1.24-.342h-2.029v2.664h2.018a2.311 2.311 0 0 0 .678-.093 1.685 1.685 0 0 0 .536-.268 1.185 1.185 0 0 0 .35-.428 1.248 1.248 0 0 0 .127-.573 1.156 1.156 0 0 0-.443-.964z"
        data-name="Path 15721"
        style={{
          fill: '#0d206c',
        }}
        transform="translate(-169.685 -93.045)"
      />
      <path
        d="M274.471 144h-.741v-5.875h-2.2v-.685h5.141v.685h-2.2z"
        data-name="Path 15722"
        style={{
          fill: '#0d206c',
        }}
        transform="translate(-180.205 -93.039)"
      />
      <path
        d="M293.56 141.836a3.413 3.413 0 0 1-.685 1.083 3.254 3.254 0 0 1-1.057.745 3.539 3.539 0 0 1-2.729 0 3.232 3.232 0 0 1-1.731-1.813 3.615 3.615 0 0 1 0-2.591 3.413 3.413 0 0 1 .685-1.083 3.254 3.254 0 0 1 1.057-.745 3.539 3.539 0 0 1 2.729 0 3.219 3.219 0 0 1 1.054.737 3.306 3.306 0 0 1 .681 1.076 3.625 3.625 0 0 1 0 2.595zm-.715-2.338a2.556 2.556 0 0 0-.54-.86 2.639 2.639 0 0 0-.819-.581 2.443 2.443 0 0 0-1.035-.216 2.5 2.5 0 0 0-1.035.212 2.443 2.443 0 0 0-.812.577 2.674 2.674 0 0 0-.529.856 2.9 2.9 0 0 0-.194 1.054 2.852 2.852 0 0 0 .194 1.057 2.556 2.556 0 0 0 .54.86 2.638 2.638 0 0 0 .819.581 2.443 2.443 0 0 0 1.035.216 2.5 2.5 0 0 0 1.035-.212 2.443 2.443 0 0 0 .812-.577 2.674 2.674 0 0 0 .529-.856 2.9 2.9 0 0 0 .194-1.054 2.852 2.852 0 0 0-.193-1.055z"
        data-name="Path 15723"
        style={{
          fill: '#0d206c',
        }}
        transform="translate(-189.992 -92.863)"
      />
      <path
        d="M322.336 142.024a3.044 3.044 0 0 1-.715 1.046 3.358 3.358 0 0 1-1.106.692 3.835 3.835 0 0 1-1.411.253h-2.274v-6.555h2.27a3.85 3.85 0 0 1 1.411.249 3.29 3.29 0 0 1 1.106.689 3.05 3.05 0 0 1 .715 1.039 3.433 3.433 0 0 1 0 2.587zm-.707-2.3a2.417 2.417 0 0 0-.543-.83 2.513 2.513 0 0 0-.856-.551 3.022 3.022 0 0 0-1.124-.2h-1.538v5.19h1.532a3.1 3.1 0 0 0 1.124-.2 2.417 2.417 0 0 0 .856-.547 2.5 2.5 0 0 0 .543-.819 2.784 2.784 0 0 0 0-2.04z"
        data-name="Path 15724"
        style={{
          fill: '#0d206c',
        }}
        transform="translate(-208.641 -93.051)"
      />
      <path
        d="M341.239 138.118h-4v2.237h3.578v.674h-3.578v2.293h4.047V144H336.5v-6.56h4.739v.674z"
        data-name="Path 15725"
        style={{
          fill: '#0d206c',
        }}
        transform="translate(-220.989 -93.039)"
      />
      <path
        d="M364.049 142.208h-.037l-2.39-3.5v5.3h-.722v-6.558h.748l2.39 3.578 2.39-3.578h.748v6.556h-.741v-5.312l-2.39 3.514z"
        data-name="Path 15726"
        style={{
          fill: '#0d206c',
        }}
        transform="translate(-236.305 -93.045)"
      />
      <path
        d="M388.42 141.836a3.414 3.414 0 0 1-.685 1.083 3.255 3.255 0 0 1-1.057.745 3.539 3.539 0 0 1-2.729 0 3.232 3.232 0 0 1-1.731-1.813 3.615 3.615 0 0 1 0-2.591 3.413 3.413 0 0 1 .685-1.083 3.254 3.254 0 0 1 1.057-.745 3.539 3.539 0 0 1 2.729 0 3.219 3.219 0 0 1 1.054.737 3.306 3.306 0 0 1 .681 1.076 3.625 3.625 0 0 1 0 2.595zm-.715-2.338a2.556 2.556 0 0 0-.54-.86 2.638 2.638 0 0 0-.819-.581 2.442 2.442 0 0 0-1.035-.216 2.5 2.5 0 0 0-1.035.212 2.443 2.443 0 0 0-.812.577 2.675 2.675 0 0 0-.529.856 2.9 2.9 0 0 0-.194 1.054 2.852 2.852 0 0 0 .194 1.057 2.556 2.556 0 0 0 .54.86 2.639 2.639 0 0 0 .819.581 2.443 2.443 0 0 0 1.035.216 2.5 2.5 0 0 0 1.035-.212 2.442 2.442 0 0 0 .812-.577 2.674 2.674 0 0 0 .529-.856 2.9 2.9 0 0 0 .194-1.054 2.853 2.853 0 0 0-.193-1.055z"
        data-name="Path 15727"
        style={{
          fill: '#0d206c',
        }}
        transform="translate(-249.537 -92.863)"
      />
      <path
        d="M408.955 137.45h.722v6.556h-.592l-4.233-5.376v5.376h-.722v-6.556h.692l4.132 5.257z"
        data-name="Path 15728"
        style={{
          fill: '#0d206c',
        }}
        transform="translate(-263.441 -93.045)"
      />
      <path
        d="M425.7 144h-.741v-5.875h-2.2v-.685h5.141v.685h-2.2z"
        data-name="Path 15729"
        style={{
          fill: '#0d206c',
        }}
        transform="translate(-275.136 -93.039)"
      />
      <path
        d="M445.059 138.118h-4v2.237h3.578v.674h-3.578v2.293h4.047V144h-4.786v-6.56h4.739v.674z"
        data-name="Path 15730"
        style={{
          fill: '#0d206c',
        }}
        transform="translate(-286.159 -93.039)"
      />
      <path
        d="M461.175 137.45h.8l-2.818 6.6h-.657l-2.818-6.6h.823l2.334 5.647 2.342-5.647z"
        data-name="Path 15731"
        style={{
          fill: '#0d206c',
        }}
        transform="translate(-295.8 -93.045)"
      />
      <path
        d="M476.961 137.45v6.556h-.741v-6.556z"
        data-name="Path 15732"
        style={{
          fill: '#0d206c',
        }}
        transform="translate(-308.694 -93.045)"
      />
      <path
        d="M488.886 142.024a3.045 3.045 0 0 1-.715 1.046 3.358 3.358 0 0 1-1.106.692 3.835 3.835 0 0 1-1.411.253h-2.274v-6.555h2.275a3.849 3.849 0 0 1 1.411.249 3.29 3.29 0 0 1 1.106.689 3.05 3.05 0 0 1 .715 1.039 3.432 3.432 0 0 1 0 2.587zm-.707-2.3a2.417 2.417 0 0 0-.543-.83 2.513 2.513 0 0 0-.856-.551 3.022 3.022 0 0 0-1.124-.2h-1.538v5.19h1.538a3.1 3.1 0 0 0 1.124-.2 2.417 2.417 0 0 0 .856-.547 2.5 2.5 0 0 0 .543-.819 2.784 2.784 0 0 0 0-2.04z"
        data-name="Path 15733"
        style={{
          fill: '#0d206c',
        }}
        transform="translate(-313.188 -93.051)"
      />
      <path
        d="M507.789 138.118h-4v2.237h3.578v.674h-3.578v2.293h4.047V144h-4.786v-6.56h4.739v.674z"
        data-name="Path 15734"
        style={{
          fill: '#0d206c',
        }}
        transform="translate(-325.536 -93.039)"
      />
      <path
        d="M525.58 141.836a3.412 3.412 0 0 1-.685 1.083 3.254 3.254 0 0 1-1.057.745 3.539 3.539 0 0 1-2.729 0 3.231 3.231 0 0 1-1.731-1.813 3.615 3.615 0 0 1 0-2.591 3.414 3.414 0 0 1 .685-1.083 3.254 3.254 0 0 1 1.057-.745 3.539 3.539 0 0 1 2.729 0 3.218 3.218 0 0 1 1.054.737 3.308 3.308 0 0 1 .681 1.076 3.624 3.624 0 0 1 0 2.595zm-.715-2.338a2.554 2.554 0 0 0-.54-.86 2.64 2.64 0 0 0-.819-.581 2.443 2.443 0 0 0-1.035-.216 2.5 2.5 0 0 0-1.035.212 2.444 2.444 0 0 0-.812.577 2.675 2.675 0 0 0-.529.856 2.9 2.9 0 0 0-.194 1.054 2.852 2.852 0 0 0 .194 1.057 2.556 2.556 0 0 0 .54.86 2.638 2.638 0 0 0 .819.581 2.443 2.443 0 0 0 1.035.216 2.5 2.5 0 0 0 1.035-.212 2.442 2.442 0 0 0 .812-.577 2.673 2.673 0 0 0 .529-.856 2.9 2.9 0 0 0 .194-1.054 2.852 2.852 0 0 0-.193-1.055z"
        data-name="Path 15735"
        style={{
          fill: '#0d206c',
        }}
        transform="translate(-335.636 -92.863)"
      />
    </g>
    <path
      d="M45.858 53.638a13.59 13.59 0 0 0-5.588 10.625c0 8.95 6.6 15.494 14.642 15.494s14.649-6.545 14.649-15.494a13.48 13.48 0 0 0-5.152-10.282V39C75.2 42.53 83.61 51.941 83.61 64.2c0 16.793-12.058 28.636-28.7 28.636S26.22 80.99 26.22 64.2c0-12.427 8.626-21.92 19.638-25.326v14.761z"
      data-name="Path 15736"
      style={{
        fillRule: 'evenodd',
        fill: '#0d206c',
      }}
      transform="translate(-26.22 -31.164)"
    />
    <path
      d="M97.524 19.681v14.974A14.932 14.932 0 0 0 78.97 34.3V19.54a30.572 30.572 0 0 1 18.554.145z"
      data-name="Path 15737"
      style={{
        fill: '#447dd7',
      }}
      transform="translate(-59.331 -18.17)"
    />
  </svg>
);

export default CombinationLogo;
